import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Whychoosespeeech() {
  return (
    <section className="voice_services why_choose_speech p-100 overflow-x-hidden">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why Choose <span>TekRevol</span> As Your{" "}
              <span>Real Estate App</span> Development Company?
            </h2>
            <p>
              At TekRevol, we make use of cutting-edge technology to offer
              various clients safe and engaging real estate mobile applications.
              With our real estate app development solutions, agents, brokers,
              and property managers can enhance functionality, security, and
              efficiency through tailored technologies.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Global Buyers Access</h5>
                    <p>
                      We develop a real estate application that will enable
                      buyers and sellers from different regions of the world to
                      easily access.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Maintain Large Inventory</h5>
                    <p>
                      Efficiently manage a vast inventory of properties with our
                      scalable app solutions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Unique Approach</h5>
                    <p>
                      Our tailored development process ensures your app stands
                      out in the competitive real estate market.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Source Code & IP Rights</h5>
                    <p>
                      We provide complete ownership of source code and
                      intellectual property for full control.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Scalable Architecture</h5>
                    <p>
                      Our systems are designed to scale with your company,
                      effortlessly managing a growing user base and rising data
                      volumes.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Flexible Integration</h5>
                    <p>
                      Integrate your app with ease into third-party services and
                      APIs, allowing you to expand its functionality as your
                      needs change.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
